import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import tableIconUserShare from '../../../assets/images/tabler-icon-user-share.svg';
import EmptyLeaderboardIcon from '../../../assets/svgComponents/EmptyLeaderboardIcon';
import ButtonWithIcon from '../../shared/ButtonWithIcon/ButtonWithIcon';

export const EmptyLeaderboard = () => {
  const { t } = useTranslation('dashboard');
  const navigate = useNavigate();

  return (
    <div className="p-3 text-center flex flex-col items-center w-full border-none bg-transparent">
      <EmptyLeaderboardIcon className="h-12 w-12 text-gray-300 mx-auto mb-3" />
      <h2 className="text-lg font-bold">{t('leaderboard.emptyTitle')}</h2>
      <p className="text-gray-600">{t('leaderboard.emptyDescription')}</p>
      <div className="mt-3">
        <ButtonWithIcon
          text={t('leaderboard.startReferring')}
          img={tableIconUserShare}
          imgClassName="btn-icon-36"
          textClassName="btn-icon-text-tertiary-40"
          variant="tertiary-36"
          onClick={() => navigate('/jobs')}
        />
      </div>
    </div>
  );
};
